export default (state = null, action) => {
  switch (action.type) {
    case 'LOGIN':
      return action.userUid;
    case 'LOGOUT':
      return null;
    default:
      return state;
  }
};
